import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Store } from '@ngrx/store';

import { AbstractWizardStepComponent, CheckInTaskCode, WizardStep } from 'src/app/features/wizard';
import { RootStoreState } from 'src/app/store';

import { AudioVideoCheckActions } from '../../store';
import { AudioVideoConnectionMonitorActions } from 'src/app/features/audio-video-connection-monitor/store';

@Component({
    selector: 'app-audio-video-check-in-step',
    templateUrl: './audio-video-check-in-step.component.html',
    standalone: false
})
export class AudioVideoCheckInStepComponent extends AbstractWizardStepComponent {
  constructor(private readonly store: Store<RootStoreState.State>) {
    super(store);

    this.stepMetadata = {
      stepName: 'Camera and Audio',
      checkInTaskCode: CheckInTaskCode.AudioVideoCheck,
    } as WizardStep;

    this.formStep = new UntypedFormGroup({});
  }

  public onStepVisible(): void {
    this.store.dispatch(AudioVideoCheckActions.AudioVideoCheckStarted());
    this.store.dispatch(
      AudioVideoConnectionMonitorActions.SetIsOnAudioVideoPage({
        payload: { isOnAudioVideoConfigurationPage: true },
      })
    );
  }

  public onStepHidden(): void {
    this.store.dispatch(
      AudioVideoConnectionMonitorActions.SetIsOnAudioVideoPage({
        payload: { isOnAudioVideoConfigurationPage: false },
      })
    );
  }

  goToNextStep() {
    super.goToNextStep();
  }
}
